@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.AddStepButton {
  width: 100%;

  >button {
    border: 0;
    background: transparent;
    text-align: left;
    width: 100%;
    padding: 0;
    cursor: pointer;

    :hover {
      background: $theme-color-table-hover;

      p {
        strong {
          color: $theme-color-tab-label-selected !important;
        }
      }

      svg {
        background: $theme-color-secondary-button-hover;
      }
    }

    :active {
      svg {
        background: $theme-color-secondary-button-active;
      }
    }
  }

  .ContentWrapper {
    display: grid;
    grid-template-columns: 1fr auto auto;
    column-gap: 8px;
    padding: 8px 12px;
    align-items: center;
    word-wrap: break-word;
    word-break: break-all;

    .NoCounter {
      width: 25px;
    }

    .Counter {
      border: 1px solid $theme-hover-focus-shadow;
      border-radius: 4px;
      background: $theme-dropdown-selected-background-color;
      width: 25px;
      text-align: center;
      padding: 3px 2px;

      :hover {
        background: transparent;
      }
    }

    .PlusIcon {
      padding: 4px;
      border-radius: 3px;
      color: $theme-filter-icon-color;
    }
  }
}
